"use strict";
exports.addDays = addDays;
var _index = require("./toDate.js");
var _index2 = require("./constructFrom.js");
function addDays(date, amount) {
  const _date = (0, _index.toDate)(date);
  if (isNaN(amount)) return (0, _index2.constructFrom)(date, NaN);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
